// extracted by mini-css-extract-plugin
export default {"anchorLink":"breadcrumbs_anchorLink__FTuQK"};